import { BaseClass } from './base'

export class ConfigClass extends BaseClass {
  modelRef = {
    title: '',
    name: '',
    value: '',
    group: 0,
    sort: 0,
    type: 1,
    remark: ''
  }

  rulesRef = {
    title: [
      {
        required: true,
        message: '请输入名称'
      }
    ],
    name: [
      {
        required: true,
        message: '请输入标识'
      }
    ]
  }

  create (data) {
    return this.post(this.config, data)
  }

  gets () {
    return this.get(this.config)
  }

  detail (key) {
    return this.get(this.config + `/${key}`)
  }

  update (data) {
    return this.put(this.config, data)
  }
}
